  export const HOME = '/';
export const DASHBOARD = '/dashboard';
export const ABOUT = '/about';
export const HELP = '/help';